import type { FC } from 'react';
import React, { useContext } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { css } from '@compiled/react';

import Lozenge from '@atlaskit/lozenge';
import { token } from '@atlaskit/tokens';

import { PageCardContext } from '../PageCardContext.ts';

const i18n = defineMessages({
	unpublished: {
		id: 'page-card.lozenge.unpublished',
		defaultMessage: 'unpublished changes',
		description:
			'The text is shown as a status lozenge on a page card to indicate the page has unpublished changes that have not yet been published to viewers.',
	},
	draft: {
		id: 'page-card.lozenge.draft',
		defaultMessage: 'draft',
		description:
			'The text is shown as a status lozenge on a page card to indicate the page is currently a draft and has not been published yet.',
	},
});

const columnSpacingStyles = css({
	marginTop: token('space.200'),
});

type StatusLozengeProps = {
	isInColumn?: boolean;
};

export const StatusLozenge: FC<StatusLozengeProps> = ({ isInColumn }) => {
	const { status } = useContext(PageCardContext);

	const isValidStatus = status && !!i18n[status];
	return isValidStatus ? ( // TODO: css prop is still typed for emotion
		<div css={isInColumn && (columnSpacingStyles as any)}>
			<Lozenge appearance="default">
				<FormattedMessage {...i18n[status]} />
			</Lozenge>
		</div>
	) : null;
};
